import { SectionProps } from '@wrisk/ui-components'
import React, { FC } from 'react'

import { isRenewalPolicy, Policy } from '../../../domain'
import { usePrincipal } from '../../authentication'
import { AutoRenewalSection } from './AutoRenewalSection'

export interface PolicyAutoRenewalSectionProps extends SectionProps {
  policy: Policy
  subheader?: string
}

export const PolicyAutoRenewalSection: FC<PolicyAutoRenewalSectionProps> = ({
  policy,
  subheader,
  ...props
}) => {
  const {
    apiClient: { setPolicyAutoRenewalEnabled },
  } = usePrincipal()

  const {
    policyId,
    policyDetail: { renewalStopped, autoRenewalEnabled },
  } = policy

  if (renewalStopped || (policy && isRenewalPolicy(policy))) {
    return null
  }

  return (
    <AutoRenewalSection
      policyOrProposalId={policyId}
      isInitiallyEnabled={autoRenewalEnabled}
      subheader={subheader}
      invokeApi={setPolicyAutoRenewalEnabled}
      {...props}
    />
  )
}
